var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M66 2.75H15C13.2051 2.75 11.75 4.20507 11.75 6V26C11.75 27.7949 13.2051 29.25 15 29.25H66C67.7949 29.25 69.25 27.7949 69.25 26V6C69.25 4.20507 67.7949 2.75 66 2.75Z",
    stroke: "#999999",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M23 19.5L36 13.5L34 19L49 13L48 17L57.5 12",
    stroke: "#999999",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M2.91371 72.25V73.3363H4H26.5949H27.6812V72.25V60.9525C27.6812 55.5531 23.304 51.1759 17.9046 51.1759H12.6903C7.29085 51.1759 2.91371 55.5531 2.91371 60.9525V72.25Z",
    stroke: "#999999",
    strokeWidth: 2.17258,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M21.8177 42.9195V42.485C21.8177 38.7654 18.8023 35.75 15.0827 35.75C11.363 35.75 8.34766 38.7654 8.34766 42.485V42.9195C8.34766 46.6392 11.363 49.6545 15.0827 49.6545C18.8023 49.6545 21.8177 46.6392 21.8177 42.9195Z",
    stroke: "#999999",
    strokeWidth: 2.17258,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M28.1168 72.2505V73.3368H29.2031H51.798H52.8843V72.2505V60.953C52.8843 55.5536 48.5072 51.1764 43.1077 51.1764H37.8935C32.494 51.1764 28.1168 55.5535 28.1168 60.953V72.2505Z",
    stroke: "#999999",
    strokeWidth: 2.17258,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M47.0208 42.92V42.4855C47.0208 38.7659 44.0054 35.7505 40.2858 35.7505C36.5661 35.7505 33.5508 38.7659 33.5508 42.4855V42.92C33.5508 46.6397 36.5661 49.655 40.2858 49.655C44.0054 49.655 47.0208 46.6397 47.0208 42.92Z",
    stroke: "#999999",
    strokeWidth: 2.17258,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M53.3161 72.2505V73.3368H54.4023H76.9972H78.0835V72.2505V60.953C78.0835 55.5536 73.7064 51.1764 68.3069 51.1764H63.0927C57.6932 51.1764 53.3161 55.5535 53.3161 60.953V72.2505Z",
    stroke: "#999999",
    strokeWidth: 2.17258,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M72.22 42.92V42.4855C72.22 38.7659 69.2047 35.7505 65.485 35.7505C61.7654 35.7505 58.75 38.7659 58.75 42.4855V42.92C58.75 46.6397 61.7654 49.655 65.485 49.655C69.2047 49.655 72.22 46.6397 72.22 42.92Z",
    stroke: "#999999",
    strokeWidth: 2.17258,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingApps);
export default __webpack_public_path__ + "static/media/training_apps.fc7a41dde7d6b68ba647ce2574235a02.svg";
export { ForwardRef as ReactComponent };